import { selectTradeInBrandSelectedValue } from 'store/widgets/TradeInNewCalculator/brand/selectors';
import { selectTradeInCapacitySelectedValue } from 'store/widgets/TradeInNewCalculator/capacity/selectors';
import { selectTradeInTypeSelectedValue } from 'store/widgets/TradeInNewCalculator/deviceType/selectors';
import { getTradeInDeviceMaxPrice } from 'store/widgets/TradeInNewCalculator/maxPrice/selectors';
import { selectTradeInModelSelectedValue } from 'store/widgets/TradeInNewCalculator/model/selectors';

export const selectTradeInIsValid = (state) => {
  const isTypeValid = selectTradeInTypeSelectedValue(state) !== '';
  const isBrandValid = selectTradeInBrandSelectedValue(state) !== '';
  const isModelValid = selectTradeInModelSelectedValue(state) !== '';
  const isCapacityValid = selectTradeInCapacitySelectedValue(state) !== '';

  return isTypeValid && isBrandValid && isModelValid && isCapacityValid;
};

export const selectTradeInSummary = (state) => ({
  capacity: selectTradeInCapacitySelectedValue(state),
  deviceBrand: selectTradeInBrandSelectedValue(state),
  deviceModel: selectTradeInModelSelectedValue(state),
  deviceType: selectTradeInTypeSelectedValue(state),
  maxPrice: getTradeInDeviceMaxPrice(state),
});
